import React, { Fragment, useEffect, useState } from 'react';
import format from 'date-fns/format';
import { faSearch, faPencilAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProgramRequestEditProgramRequestModal } from './program-request-edit-program-modal';
import { academicProgramsService } from '../../../services';
import { UrlEnum } from '../../../shared';
import { ProgramRequestEditSplitProgramRequestModal } from './program-request-edit-split-program-modal';

export const RequestDetails = ({
    requestDetails,
    setRequestDetails,
    showBackButton,
}) => {
    const programStatusOptions = [
        { label: 'New', value: 0 },
        { label: 'Active', value: 1 },
        { label: 'Suspended', value: 3 },
        { label: 'Eliminated', value: 4 },
        { label: 'Merged', value: 5 },
    ];
    const formatCreatedDate = createdDate => {
        if (createdDate == null) return <Fragment></Fragment>;
        const date = new Date(createdDate);
        return <Fragment>{format(date, 'M/d/yyyy')}</Fragment>;
    };
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [isSplitModalOpen, setIsSplitModalOpen] = useState(false);
    const [degreeLevels, setDegreeLevels] = useState([]);
    const [details, setDetails] = useState([]);
    useEffect(() => {
        setDetails(requestDetails ?? []);
    }, [requestDetails]);

    const EMPTY_STATE = {
        locations: null,
        requestId: 0,
        programName: '',
        degreeLevel: null,
        cipCode: '',
        cipCodeTitle: '',
        comments: '',
        creditRequirementMinimum: '',
        creditRequirementMaximum: '',
        programDistanceEd: null,
        programDistanceEdOnline: null,
        files: [],
        programStatus: [],
    };
    const [INITIAL_STATE, setINITIAL_STATE] = useState(EMPTY_STATE);
    useEffect(() => {
        let programStatusCheck = programStatusOptions.find(
            x => x.label === details.programStatus
        );
        if (programStatusCheck === undefined) {
            programStatusCheck = programStatusOptions.find(
                x => x.value === details.programStatus
            );
        }
        const filledState = {
            locations: details.locations?.map(x => {
                return {
                    label: x.locationName,
                    value: x.locationId,
                    statusId: x.statusId,
                };
            }),
            requestId: details.requestID,
            programName: details.programName ?? '',
            degreeLevel: degreeLevels
                ? degreeLevels.find(x => details.degreeLevelId === x.value)
                : null,
            cipCode: details.cipCode
                ? {
                      value: details.cipCode,
                      label: `${details.cipCode} - ${details.cipTitle}`,
                  }
                : '',
            comments: '',
            creditRequirementMinimum: details.creditRequirementMinimum,
            creditRequirementMaximum: details.creditRequirementMaximum,
            programDistanceEd: getDeliveryMode(details.deliveryMode),
            programDistanceEdOnline: getDeliveryModeOnline(details.deliveryModeOnline),
            programId: details.programID,
            files: [],
            programStatus: programStatusCheck,
            requestType: details.typeId,
        };
        setINITIAL_STATE(filledState);
    }, [details, degreeLevels]);

    useEffect(() => {
        const getDegreeLevel = async () => {
            const degreeLevels = await academicProgramsService.getDegreeLevels();
            const onlyCertificates = degreeLevels?.filter(
                x => !['00', '03', '05', '07'].includes(x.label)
            );
            const degreeLevelsMapped = degreeLevels?.map(x => {
                return { label: x.value, value: x.label };
            });
            setDegreeLevels(degreeLevelsMapped);
        };
        getDegreeLevel();
    }, []);

    const getDeliveryMode = deliveryMode => {
        console.log(deliveryMode)
        if (deliveryMode === null || deliveryMode === undefined) return null;
        if (deliveryMode === 'On Campus and Online') {
            return 3;
        } else if (deliveryMode === 'On Campus Only') {
            return 1;
        } else {
            return 2;
        }
    };
    const getDeliveryModeOnline = deliveryMode => {
        if (deliveryMode === null || deliveryMode === undefined) return null;
        if (deliveryMode === '100% Online') {
            return 1;
        } else if (deliveryMode === 'Blended') {
            return 2;
        } else {
            return 0;
        }
    };
    return (
        <Fragment>
            <section className="request-details">
                {showBackButton && (
                    <div className="d-md-flex align-items-center justify-content-between">
                        <a href={UrlEnum.INSTITUTION_SEARCH_ACADEMIC_PROGRAM_REQUESTS}>
                            <FontAwesomeIcon icon={faArrowLeft} /> Back to all program
                            requests
                        </a>
                    </div>
                )}
                <div className="request-content">
                    <h2 className="text-strong mb-2">{details.programName}</h2>
                    <h5 className="text-600 mb-4">{details.institutionName}</h5>
                    <ul className="list-group list-group-flush bg-none">
                        <li className="list-group-item px-0">
                            <label className="text-muted text-600">Request Type</label>
                            <p className="m-0">{details.description}</p>
                        </li>
                        <li className="list-group-item px-0">
                            <label className="text-muted text-600">Requested On</label>
                            <p className="m-0">{formatCreatedDate(details.createdOn)}</p>
                        </li>
                        <li className="list-group-item px-0">
                            <label className="text-muted text-600">Program ID</label>
                            <p className="m-0">{details.programID}</p>
                        </li>
                        <li className="list-group-item px-0">
                            <label className="text-muted text-600">Degree Level</label>
                            <p className="m-0">{details.degreeLevel}</p>
                        </li>
                        <li className="list-group-item px-0">
                            <label className="text-muted text-600">CIP</label>
                            <p className="m-0">{details.cipCode}</p>
                        </li>
                        <li className="list-group-item px-0">
                            <label className="text-muted text-600">CIP Title</label>
                            <p className="m-0">{details.cipTitle}</p>
                        </li>
                        <li className="list-group-item px-0">
                            <label className="text-muted text-600">Delivery Mode</label>
                            <p className="m-0">{details.deliveryMode}</p>
                        </li>
                        <li className="list-group-item px-0">
                            <label className="text-muted text-600">
                                Supporting Documentation
                            </label>
                            {details.requestAttachments?.map(file => (
                                <p
                                    key={file.id}
                                    className="m-0 text-primary"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() =>
                                        academicProgramsService.downloadAttachment(
                                            file.id,
                                            file.fileName
                                        )
                                    }
                                >
                                    {file.fileName}
                                </p>
                            ))}
                        </li>
                    </ul>
                </div>
                {(requestDetails.status === 'Submitted' ||
                    requestDetails.status === 'Awaiting Institution') && (
                    <button
                        type="button"
                        data-toggle="modal"
                        data-target="#editRequestModal"
                        className="btn btn-primary btn-block"
                        onClick={() => {
                            if (details.typeId !== '7') setIsEditOpen(true);
                            else setIsSplitModalOpen(true);
                        }}
                    >
                        <i className="far"></i>
                        <FontAwesomeIcon icon={faPencilAlt} /> Edit Program Request
                    </button>
                )}
            </section>
            <ProgramRequestEditProgramRequestModal
                isOpen={isEditOpen}
                toggle={() => setIsEditOpen(false)}
                institutions={{
                    value: details.institutionId,
                    label: details.institutionName,
                }}
                degreeLevels={degreeLevels}
                INITIAL_STATE={INITIAL_STATE}
                details={details}
                setDetails={setRequestDetails}
            ></ProgramRequestEditProgramRequestModal>
            <ProgramRequestEditSplitProgramRequestModal
                isOpen={isSplitModalOpen}
                toggle={() => setIsSplitModalOpen(false)}
                institutions={{
                    value: details.institutionId,
                    label: details.institutionName,
                }}
                degreeLevels={degreeLevels}
                INITIAL_STATE={INITIAL_STATE}
                details={details}
                setDetails={setRequestDetails}
            ></ProgramRequestEditSplitProgramRequestModal>
        </Fragment>
    );
};
